import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Main from '../views/Main.vue';
import Advice from '../views/Advice.vue';
import Search from '../views/Search.vue';
import Change from '../views/Change.vue';
import New from '../views/New.vue';
import Place from '../views/Place.vue';
import Choice from '../views/Choice.vue';
import Comple from '../views/Comple.vue';
import Cancel from '../views/Cancel.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Main',
    component: Main
  },
  {
    path: '/advice',
    name: 'Advice',
    component: Advice
  },
  {
    path: '/new',
    name: 'New',
    component: New
  },
  {
    path: '/place',
    name: 'Place',
    component: Place
  },
  {
    path: '/search',
    name: 'Search',
    component: Search
  },
  {
    path: '/change',
    name: 'Change',
    component: Change
  },
  {
    path: '/choice',
    name: 'Choice',
    component: Choice
  },
  {
    path: '/comple',
    name: 'Comple',
    component: Comple
  },
  {
    path: '/cancel',
    name: 'Cancel',
    component: Cancel
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
